module.exports = __webpack_public_path__ + "static/img/36754.f68f107.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/36754.jpg
// module id = KILR
// module chunks = 1